export enum Role {
    SUPER_OWNER = 'SUPER_OWNER',
    OWNER = 'OWNER',
    ADMIN = 'ADMIN',
    EMPLOYEE = 'EMPLOYEE',
    TEAM_ACCOUNT = 'TEAM_ACCOUNT',
}
